import axios from 'axios'

const VueGotoInstance = axios.create()
VueGotoInstance.defaults.baseURL = process.env.VUE_APP_GOTOWEBINAR_BASE_URL

export {VueGotoInstance}
